import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import VueTippy from 'vue-tippy';

const pinia = createPinia();

export default function init() {
  const element = document.getElementById('productDetailTabs');

  if (element) {
    const app = createApp(App, { ...element.dataset });

    app.use(pinia);
    app.use(VueTippy);
    app.mount('#productDetailTabs');
  }
}
